import React from "react";
import { Link } from "react-router-dom";
import { Images, Rocket, Loader2, ArrowRight } from "lucide-react";
import { BrandHome } from "@/components/BrandHome";
import { Button } from "@/components/ui/button";
import Seo, { SITE_URL } from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import ScrollToTop from "@/components/ScrollToTop";
import { SampleGrid, useShowcase } from "@/components/Showcase";
import { track } from "@/lib/funnel";

/** مكتبة العينات العامة: كل ما اختاره الأدمن من إنتاج المنصة، بمعاينة كاملة */
export default function Samples() {
  const items = useShowcase();
  return (
    <div className="min-h-screen bg-background text-foreground" dir="rtl">
      <Seo title="مكتبة العينات — صور وفيديوهات من إنتاج رواج الذكية" description="نماذج حقيقية من صور وفيديوهات إعلانية أنتجتها منصة رواج الذكية بالذكاء الاصطناعي للسوق السعودي." path="/samples" canonical={`${SITE_URL}/samples`} />
      <header className="glass border-b border-border sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
          <BrandHome />
          <div className="flex items-center gap-3 text-sm">
            <Link to="/" className="text-muted-foreground hover:text-foreground transition inline-flex items-center gap-1" data-testid="samples-back"><ArrowRight className="w-4 h-4" /> الرئيسية</Link>
            <Link to="/register" onClick={() => track("cta_click")}><Button size="sm" className="bg-primary hover:bg-primary/90 text-white">ابدأ الآن</Button></Link>
          </div>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 py-12" data-testid="samples-page">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 text-primary text-sm font-bold mb-3"><Images className="w-4 h-4" /> مكتبة العينات</div>
          <h1 className="text-2xl sm:text-3xl font-bold">صور وفيديوهات من إنتاج رواج الذكية</h1>
          <p className="text-sm text-muted-foreground mt-2">كل عينة هنا أُنتجت بالكامل بالذكاء الاصطناعي داخل المنصة — اضغط أي عينة لمعاينتها بالحجم الكامل</p>
        </div>
        {items === null ? (
          <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 animate-spin text-primary" /></div>
        ) : items.length === 0 ? (
          <p className="text-center text-muted-foreground py-20">لا توجد عينات معروضة حاليًا.</p>
        ) : (
          <SampleGrid items={items} />
        )}
        <div className="text-center mt-12">
          <Link to="/register" onClick={() => track("cta_click")}>
            <Button size="lg" className="gap-2 font-bold h-12 px-8" data-testid="samples-cta"><Rocket className="w-5 h-5" /> أنتج مثلها لمشروعك مجانًا</Button>
          </Link>
        </div>
      </main>
      <SiteFooter />
      <ScrollToTop />
    </div>
  );
}
